import refs from '../helpers/refs'

class MNewsletter {
  constructor (el) {
    this.$form = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    this.$form.addEventListener('submit', (e) => {
      e.preventDefault()
      this.onSubmit()
    })
  }

  onSubmit () {
    this.setMessage('')
    this.setStatus('loading')

    fetch(this.$form.action, {
      email: this.$refs.email.value
    })
      .then(response => response.json())
      .then(response => this.onSuccess(response))
      .catch(error => this.onError(error))
  }

  onSuccess (response) {
    if (response?.success) {
      this.setMessage(response?.message)
      this.setStatus('success')
    } else {
      this.onError(response)
    }
  }

  onError (error) {
    this.setMessage(error?.message)
    this.setStatus('error')

    setTimeout(() => {
      this.setStatus('')
    }, 3e3)
  }

  setMessage (message) {
    this.$refs.message.innerText = message
  }

  setStatus (status) {
    if (status) {
      this.$form.dataset.status = status
    } else {
      delete this.$form.dataset.status
    }
  }
}

document.querySelectorAll('.m-newsletter').forEach(el => new MNewsletter(el))
